"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emojiMart = require("emoji-mart");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

class EmojiButton extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "state", {
      isEmojiMenuOpen: false,
      buttonClassName: '',
      isLoaded: false
    });
    (0, _defineProperty2.default)(this, "onDocumentClick", e => {
      const {
        isEmojiMenuOpen
      } = this.state;

      if (!isEmojiMenuOpen) {
        return;
      }

      if (!e.target.closest(".".concat(this.getUniqueClassName()))) {
        this.closeEmojiPicker();
      }
    });
    (0, _defineProperty2.default)(this, "openEmojiPicker", () => {
      this.setState({
        isEmojiMenuOpen: true
      });
    });
    (0, _defineProperty2.default)(this, "closeEmojiPicker", () => {
      this.setState({
        isEmojiMenuOpen: false
      });
    });
    (0, _defineProperty2.default)(this, "onClick", (emoji, e) => {
      e.stopPropagation();
      const {
        onSelected
      } = this.props;
      this.closeEmojiPicker();
      onSelected(emoji);
    });
    EmojiButton.uId++;
    this.uId = EmojiButton.uId;
  }

  componentDidMount() {
    document.addEventListener('click', this.onDocumentClick);
    this.setState({
      buttonClassName: this.getUniqueClassName(),
      isLoaded: true
    });
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  getUniqueClassName() {
    return "emoji-button-".concat(this.uId);
  }

  render() {
    const {
      emojiSize,
      className
    } = this.props;
    const {
      isEmojiMenuOpen,
      buttonClassName,
      isLoaded
    } = this.state;
    let style = {};

    if (isEmojiMenuOpen) {
      style = _objectSpread(_objectSpread({}, style), {}, {
        opacity: 1,
        visibility: 'visible'
      });
    } // renders the Picker component only if the isLoaded state property is true
    // because the Picker component throws a warning related to SSR. Therefore
    // we render the Picker only in the client and not in the server


    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('emoji-button', className, buttonClassName),
      onClick: this.openEmojiPicker
    }, isLoaded && /*#__PURE__*/_react.default.createElement(_emojiMart.Picker, {
      set: "emojione",
      onClick: this.onClick,
      showPreview: false,
      showSkinTones: false,
      style: style,
      emojiSize: emojiSize // the 'flags' emojies are not supported by all operating systems so we exclude it from the picker
      ,
      exclude: ['flags']
    }));
  }

}

(0, _defineProperty2.default)(EmojiButton, "propTypes", {
  onSelected: _propTypes.default.func.isRequired,
  emojiSize: _propTypes.default.number,
  className: _propTypes.default.string
});
(0, _defineProperty2.default)(EmojiButton, "defaultProps", {
  emojiSize: 19,
  className: ''
});
(0, _defineProperty2.default)(EmojiButton, "uId", 0);
var _default = EmojiButton;
exports.default = _default;